module.exports = __webpack_public_path__ + "img/main_section_img2.582c1ed6.png";